<template>
  <section class="relative py-8 bg-bsd-700 mt-12">
    <div class="container">
      <!-- <div class="grid md:grid-cols-6 grid-cols-2 justify-center gap-[30px]">
        <div class="mx-auto py-4">
          <img src="../assets/images/client/amazon.svg" class="h-6" alt="">
        </div>

        <div class="mx-auto py-4">
          <img src="../assets/images/client/google.svg" class="h-6" alt="">
        </div>

        <div class="mx-auto py-4">
          <img src="../assets/images/client/lenovo.svg" class="h-6" alt="">
        </div>

        <div class="mx-auto py-4">
          <img src="../assets/images/client/paypal.svg" class="h-6" alt="">
        </div>

        <div class="mx-auto py-4">
          <img src="../assets/images/client/shopify.svg" class="h-6" alt="">
        </div>

        <div class="mx-auto py-4">
          <img src="../assets/images/client/spotify.svg" class="h-6" alt="">
        </div>
      </div> -->
      
      <!--end grid-->
    </div><!--end container-->
  </section>
</template>

<script>
export default {
  name: 'Sponsors',
}
</script>

<style></style>